<template>
    <div
        class="alert alert-dismissible fade show"
        :class="[getClass]"
        role="alert"
    >
        {{ $t(flash.message) }}
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" @click="$emit('close')"></button>
    </div>
</template>

<script>
export default {
    name: "TopAlert",
    props: {
        flash: Object
    },
    computed: {
        getClass() {
            return 'alert-'+ this.flash.type
        }
    }
}
</script>

<style scoped>

</style>
